import axios from 'axios';
import TokenService from '../services/TokenService';
import { auth_service_api_url as API_URL, COD_PARTICIPANTE, getCanal } from '../services/backendApiService';
import GAException from '../components/GAException';
import { shouldReplay, extractRefreshedToken } from './axiosRefresh';

const instance = axios.create();

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token && !config.url.includes('/ws-user-kyc') && !config.url.includes('/kyc')) {
      config.headers.Authorization = `Bearer ${token}`; // for Spring Boot back-end
      // config.headers["x-access-token"] = token; // for Node.js Express back-end
    }
    config.headers['Codparticipante'] = COD_PARTICIPANTE;
    config.headers['Canal'] = getCanal();
    return config;
  },
  (error) => Promise.reject(error)
);

const myInterval = setInterval(() => {
  const renewToken = localStorage.getItem('renewToken');
  if (renewToken > 0) {
    localStorage.setItem('renewToken', renewToken - 5);
  }
}, 5000);

instance.interceptors.response.use(
  async (response) => {
    const renewToken = localStorage.getItem('renewToken');
    const originalConfig = response.config;
    if (!originalConfig.url.includes('inicioSesion')
      && !originalConfig.url.includes('/v1/validarToken')
      && !originalConfig.url.includes('/cerrarSesion')
      && !originalConfig.url.includes('/verificarUsuario')
      && !originalConfig.url.includes('/registrarActividadFrontend')
      && renewToken
      && renewToken === '0') {
      localStorage.setItem('renewToken', 25);
      await axios.post(
        `${API_URL}/v1/refreshToken`, {}, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TokenService.getLocalAccessToken()}`
          }
        }
      )
        // eslint-disable-next-line consistent-return
        .then((res) => {
          if (res.data.header.codReturn === '0') {
            localStorage.setItem('renewToken', 25);
            if (res.data.data) {
              // console.log(`Se actualiza el tocken -> ${res.data.data.token}`);
              TokenService.updateLocalAccessToken(res.data.data.token);
            }
          }
        })
        .catch((error) => {
          localStorage.setItem('renewToken', 0);
          GAException(error);
        });
    }
    return response;
  },
  async (err) => {
    const originalConfig = err && err.config;

    // Solo se reintenta (tras renovar el token) un request IDEMPOTENTE (GET/HEAD). Para
    // cualquier otro metodo (POST de transacciones, etc.) se rechaza con el error original:
    // los callers siguen recibiendo el 401 y lo manejan igual que antes.
    if (shouldReplay(originalConfig, err)) {
      originalConfig._retry = true;

      let token = null;
      try {
        const rs = await axios.post(
          `${API_URL}/v1/refreshToken`, {}, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${TokenService.getLocalAccessToken()}`
            }
          }
        );
        // Un token vencido responde HTTP 200 con data null: sin token no se escribe nada.
        token = extractRefreshedToken(rs);
        if (token) {
          TokenService.updateLocalAccessToken(token);
        }
      } catch (_error) {
        token = null;
      }

      if (!token) {
        return Promise.reject(err);
      }

      return instance(originalConfig);
    }

    return Promise.reject(err);
  }
);
export default instance;
